import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AlertController } from "@ionic/angular";
import { UntilDestroy } from "@ngneat/until-destroy";
import { TranslateService } from "@ngx-translate/core";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { User } from "../definition";
import { GetUser } from "../stores/app.action";
import { AppState } from "../stores/app.state";

@UntilDestroy()
@Component({
    selector: "app-profile-check",
    template: ` <ng-content></ng-content>`,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileCheckComponent implements OnInit {
    @Select(AppState.user) user$: Observable<User>;
    @Input() check: string;

    constructor(private store: Store, private alertController: AlertController, private router: Router, private translate: TranslateService) {}

    ngOnInit() {
        this.store.dispatch(new GetUser()).subscribe((state) => {

            if (!state.app.user[this.check]) {
                this.presentAlert(state.app.user);
            }
        });
    }
    async presentAlert(user: User) {
        let alertProps = {};
        if (this.check == "gender") {
            alertProps = {
                header: this.translate.instant("Entdecke Deinen persönlichen Infobereich"),
                subHeader: this.translate.instant("Was ist das?"),
                message: this.translate.instant(
                    "Alle Inhalte der YES!APP bezüglich Deiner Erkrankung und Deiner Interessen (durch die Auswahl von Themen) bekommst Du hier angezeigt. Also, triff bitte eine Auswahl, damit Du noch besser mit Informationen versorgt bist."
                ),
            };
        } else if (this.check == "zipcode") {
            alertProps = {
                header: this.translate.instant("Suche verfeinern"),
                message: this.translate.instant("Um Betroffene in Deiner Nähe zu finden musst Du zuerst Deine PLZ eingeben."),
            };
        }
        const alert = await this.alertController.create({
            ...alertProps,
            mode: "md",
            backdropDismiss: false,
            keyboardClose: false,
            buttons: [
                {
                    text: this.translate.instant("Nein, später"),
                    cssClass: "text-gray-500",
                    handler: () => {
                        this.router.navigateByUrl("/");
                    },
                },
                {
                    text: this.translate.instant("ok, jetzt eingeben"),
                    handler: () => {
                        this.router.navigate(["/profile-update"], { queryParams: { view: this.check } });
                    },
                },
            ],
        });

        await alert.present();
    }
}
